import { defineApiActionTypes } from 'store/common/action-helpers';
const prefix = 'graphql/LinkGithubButton';

export const LINKING_WITH_GITHUB = defineApiActionTypes(`${prefix}/LINKING_WITH_GITHUB`);



// WEBPACK FOOTER //
// ./src/store/graphql/LinkGithubButton/action-types.js